

export const trans_7_2=[
  {
    id:1,
    english:'When were you born? I was born in March 12 th 2003',
    vietnamese:'Bạn sinh năm nào? Tôi sinh ngày 12 tháng 3 năm 2003',
    user_message:''
  },
  {
    id:2,
    english:'She was born in 1998. She is twenty years old',
    vietnamese:'Cô ấy sinh năm 1998. Cô ấy năm nay 20 tuổi',
    user_message:''
  },
  {
    id:3,
    english:'When was your father born? My father was born in 1972',
    vietnamese:'Bố của bạn sinh năm nào? Bố tôi sinh năm 1972',
    user_message:''
  },
  {
    id:4,
    english:'Where do you live? I live in hai Phong city',
    vietnamese:'Bạn sống ở đâu? Tôi sống tại thành phố Hải Phòng',
    user_message:''
  },  
  {
    id:5,
    english:'My telephone number is 084',
    vietnamese:'Số điện thoại của tôi là 084',
    user_message:''
  },
  {
    id:6,
    english:'Where is your school?',
    vietnamese:'Trường học của bạn ở đâu?',
    user_message:''
  },
  {
    id:7,
    english:' How old are you? I am 15 years old',
    vietnamese:'Bán bao nhiêu tuổi? Toi 15 tuổi',
    user_message:''
  },
  {
    id:8,
    english:' Where does your family live?',
    vietnamese:'Gia đình của bạn sống ở đâu?',
    user_message:''
  }
]